function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { initializerDefineProperty as _initializerDefineProperty, applyDecoratedDescriptor as _applyDecoratedDescriptor } from "../_virtual/_rollupPluginBabelHelpers.js";
import { observable, computed, action } from 'mobx';
import PdfPageStore from "./PdfPageStore.js";
import range from 'lodash.range';

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _temp;

var PdfDocumentStore = (_class = (_temp = /*#__PURE__*/function () {
  function PdfDocumentStore(pdfStore, documentProxy, index) {
    var _this = this;

    _classCallCheck(this, PdfDocumentStore);

    var fields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    this.pdfStore = void 0;

    _initializerDefineProperty(this, "documentProxy", _descriptor, this);

    _initializerDefineProperty(this, "pages", _descriptor2, this);

    _initializerDefineProperty(this, "scale", _descriptor3, this);

    _initializerDefineProperty(this, "baseScale", _descriptor4, this);

    _initializerDefineProperty(this, "template", _descriptor5, this);

    _initializerDefineProperty(this, "index", _descriptor6, this);

    _initializerDefineProperty(this, "pdfLoaded", _descriptor7, this);

    _initializerDefineProperty(this, "pinchZoomTouch", _descriptor8, this);

    _initializerDefineProperty(this, "setScale", _descriptor9, this);

    _initializerDefineProperty(this, "setBaseScale", _descriptor10, this);

    _initializerDefineProperty(this, "resetScale", _descriptor11, this);

    _initializerDefineProperty(this, "resolveAllData", _descriptor12, this);

    _initializerDefineProperty(this, "setTemplate", _descriptor13, this);

    _initializerDefineProperty(this, "setIndex", _descriptor14, this);

    _initializerDefineProperty(this, "setPdfLoaded", _descriptor15, this);

    _initializerDefineProperty(this, "setPinchZoomTouch", _descriptor16, this);

    this.index = index;
    this.pdfStore = pdfStore;
    this.documentProxy = documentProxy;
    this.resolveAllData(fields);
    this.pages = range(1, documentProxy.numPages + 1).map(function (pageNum) {
      var pageFields = fields.filter(function (field) {
        return field.page === pageNum;
      });
      return new PdfPageStore(_this, pageNum, pageFields);
    });
    pdfStore.addDocument(this);
  }

  _createClass(PdfDocumentStore, [{
    key: "fields",
    get: function get() {
      return this.pages.reduce(function (acc, pageStore) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(pageStore.fields));
      }, []);
    }
  }]);

  return PdfDocumentStore;
}(), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "documentProxy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pages", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "scale", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "baseScale", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "template", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "index", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "pdfLoaded", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "pinchZoomTouch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "fields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fields"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "setScale", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (scale) {
      _this2.scale = scale;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "setBaseScale", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (baseScale) {
      _this3.baseScale = baseScale;
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "resetScale", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function () {
      _this4.scale = _this4.baseScale;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "resolveAllData", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (fields) {
      fields.forEach(function (field) {
        field.setData(_this5.pdfStore.resolveData(field.data, _this5.pdfStore.fieldData));
      });
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "setTemplate", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (template) {
      _this6.template = template;
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "setIndex", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (index) {
      _this7.index = index;
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "setPdfLoaded", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (pdfLoaded) {
      _this8.pdfLoaded = pdfLoaded;
    };
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "setPinchZoomTouch", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;

    return function (touch) {
      _this9.pinchZoomTouch = touch;
    };
  }
})), _class);
export default PdfDocumentStore;